import React from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { useCapAutofill, CapChoices, cleanCap } from "@/components/CapAutofill";

export const AUDIENCE = { direct_and_masters: "dealer diretti e master", all_dealers: "tutti i dealer" };
export const contactTitle = (c) => [c.label, c.name && c.name !== c.label && c.name].filter(Boolean).join(" · ") || "Contatto";

const Field = ({ label, k, edit, setEdit, upper, max, type, testid, placeholder }) => (
  <div><Label>{label}</Label><Input type={type} className="mt-1" value={edit[k] || ""} maxLength={max} placeholder={placeholder}
    onChange={(e) => setEdit({ ...edit, [k]: upper ? e.target.value.toUpperCase() : e.target.value })} data-testid={testid} /></div>
);

const ContactPlace = ({ edit, setEdit }) => {
  const italian = !edit.country || edit.country === "IT";
  const cap = useCapAutofill((p) => setEdit((e) => ({ ...e, city: p.city ?? e.city, province: p.province ?? e.province })));
  const onZip = (e) => { const v = italian ? cleanCap(e.target.value) : e.target.value.slice(0, 10); setEdit({ ...edit, zip: v }); if (italian) cap.lookup(v); };
  return <div>
    <div className="grid grid-cols-2 sm:grid-cols-4 gap-2">
      <div><Label>CAP</Label><Input className="mt-1" inputMode={italian ? "numeric" : undefined} value={edit.zip || ""} onChange={onZip} placeholder="Inizia dal CAP" data-testid="contact-zip" /></div>
      <div className="col-span-1"><Field label="Città" k="city" edit={edit} setEdit={setEdit} testid="contact-city" /></div>
      <Field label="Provincia" k="province" upper max={2} placeholder="RM" edit={edit} setEdit={setEdit} testid="contact-province" />
      <Field label="Paese" k="country" upper max={2} edit={edit} setEdit={setEdit} testid="contact-country" />
    </div>
    <CapChoices cap={cap} testid="contact-cap" />
  </div>;
};

export const ContactDialog = ({ edit, setEdit, onSave, loading }) => (
  <Dialog open={!!edit} onOpenChange={(o) => { if (!o) setEdit(null); }}>
    <DialogContent data-testid="contact-dialog">
      <DialogHeader><DialogTitle>{edit?.id ? "Modifica contatto" : "Nuovo contatto"}{edit?.shared ? " condiviso" : ""}</DialogTitle></DialogHeader>
      {edit && (
        <div className="space-y-3">
          {edit.shared && <div className="rounded-lg border border-primary/30 bg-primary/5 p-3 space-y-2" data-testid="contact-shared-box">
            <p className="text-xs text-muted-foreground">Comparirà già pronto nella rubrica dei dealer, che non potranno modificarlo.</p>
            <Label className="text-xs">Visibile a</Label>
            <Select value={edit.audience || "direct_and_masters"} onValueChange={(v) => setEdit({ ...edit, audience: v })}>
              <SelectTrigger data-testid="contact-audience"><SelectValue /></SelectTrigger>
              <SelectContent>
                <SelectItem value="direct_and_masters" data-testid="contact-audience-direct">Dealer diretti e master</SelectItem>
                <SelectItem value="all_dealers" data-testid="contact-audience-all">Tutti i dealer (anche quelli dei master)</SelectItem>
              </SelectContent>
            </Select>
          </div>}
          <div><Field label="Alias" k="label" edit={edit} setEdit={setEdit} placeholder="Es. Reso SIM e materiali" testid="contact-label" />
            <p className="text-xs text-muted-foreground mt-1">Il nome breve con cui il contatto compare quando scegli mittente o destinatario.</p></div>
          <div className="grid grid-cols-2 gap-2">
            <Field label="Nome" k="name" edit={edit} setEdit={setEdit} testid="contact-name" />
            <Field label="Telefono" k="phone" type="tel" edit={edit} setEdit={setEdit} testid="contact-phone" />
          </div>
          <Field label="Indirizzo" k="address" edit={edit} setEdit={setEdit} testid="contact-address" />
          <ContactPlace edit={edit} setEdit={setEdit} />
          <Field label="Email" k="email" type="email" edit={edit} setEdit={setEdit} testid="contact-email" />
          <Button className="w-full" disabled={loading} onClick={onSave} data-testid="contact-save">{loading ? "Salvataggio…" : "Salva contatto"}</Button>
        </div>
      )}
    </DialogContent>
  </Dialog>
);
